module.exports = __webpack_public_path__ + "static/img/1.123158f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/2/sp/1.png
// module id = Q/c3
// module chunks = 0